<mat-dialog-content id="forgot-modal">
  <div class="modal-content">
    <div class="modal-header p-0 mb-3">
      <h2 class="modal-title unbold">
        {{ "$olvide_mi_contrasenia" | translate }}
      </h2>
      <span class="dismiss-modal" (click)="dialogRef.close()">X</span>
    </div>
    <div class="modal-body p-0">
      <b class="mt-2 dark-text bold-text">{{
        "$enviaremos_un_mensaje_a_tu_correo_electronico" | translate
      }}</b>
      <form [formGroup]="formForgot()">
        <div class="form-group mt-4 mb-4">
          <label for="eInEmail">{{
            "$introduce_correo_electronico" | translate
          }}</label>
          <input
            type="email"
            class="form-control"
            id="eInEmail"
            formControlName="email"
            placeholder="usuario@email.com"
            appFormValidation
          />

          @if (mailNotExist()) {
            <span class="error">{{ "$email_not_exist" | translate }}</span>
          }
        </div>

        <div class="row">
          <div class="col-6">
            <button
              type="button"
              (click)="dialogRef.close()"
              class="dark-blue-border full"
            >
              {{ "$cancelar" | translate }}
            </button>
          </div>
          <div class="col-6">
            <button type="button" class="success full" (click)="close(content)">
              {{ "$continuar" | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</mat-dialog-content>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title dark-blue-text" id="modal-basic-title">
      {{ "$restablecer_contrasenia" | translate }}
    </h4>
    <button
      type="button"
      class="close py-2 px-3"
      aria-label="Close"
      (click)="d('Cross click')"
    >
      <span aria-hidden="true">X</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ "$hemos_enviado" | translate }}</p>
  </div>
</ng-template>
